import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Divider, Drawer, List, Typography } from '@mui/material';
import * as Icons from 'react-icons/all';
import NavItem from '../NavItem';




const items = [
  {
    href: '/admin/ambassadors',
    icon: Icons.MdAccountCircle,
    title: 'Ambassadors'
  },
  {
    href: '/admin/photos',
    icon: Icons.FaCamera,
    title: 'Submitted Photos'
  },
  {
    href: '/admin/photo-scheduler',
    icon: Icons.BiCalendar,
    title: 'Scheduled Photos'
  }
];



const Sidebar = ({ onMobileClose, openMobile, userInfo }) => {
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }} >
      <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', p: 2 }} >
        <Typography color="textSecondary" variant="body2" >
          {userInfo.firstName + " " + userInfo.lastName}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <NavItem href={item.href} key={item.title} title={item.title} icon={item.icon} />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Divider />
      <Box sx={{ p: 2 }}>
        <NavItem href={"/logout"} title={"Logout"} icon={Icons.GrLogout} />
      </Box>
    </Box>
  );

  return (
    <>
      {/* MOBILE */}
      <Drawer
        sx={{ display: { xs: 'block', lg: 'none' } }}
        anchor="left"
        onClose={onMobileClose}
        open={openMobile}
        variant="temporary"
        PaperProps={{
          sx: {
            width: 256
          }
        }}
      >
        {content}
      </Drawer>


      {/* DESKTOP */}
      <Drawer
        sx={{ display: { xs: 'none', lg: 'block' } }}
        anchor="left"
        open
        variant="persistent"
        PaperProps={{
          sx: {
            width: 256,
            top: 64,
            height: 'calc(100% - 64px)'
          }
        }}
      >
        {content}
      </Drawer>
    </>
  );
};

Sidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

Sidebar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default Sidebar;


